import React from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SavedStorefrontCard = ({ storefront, onRemove }) => {
  const navigate = useNavigate();

  const handleViewDetails = () => {
    navigate(`/store-details?id=${storefront?.id}`);
  };

  return (
    <div className="bg-card rounded-xl border border-border shadow-warm overflow-hidden transition-smooth hover:shadow-warm-md">
      <div className="relative h-40 md:h-48 overflow-hidden">
        <Image
          src={storefront?.image}
          alt={storefront?.imageAlt}
          className="w-full h-full object-cover"
        />
        <div className="absolute top-3 right-3">
          <button
            onClick={onRemove}
            className="w-10 h-10 rounded-full bg-background/90 backdrop-blur-sm flex items-center justify-center transition-smooth hover:bg-destructive hover:text-destructive-foreground focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3"
            aria-label="Rimuovi dai preferiti"
          >
            <Icon name="Heart" size={20} fill="currentColor" />
          </button>
        </div>
      </div>
      <div className="p-4 md:p-5">
        <div className="flex items-start gap-3 mb-3">
          <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Icon name={storefront?.categoryIcon} size={24} color="var(--color-primary)" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground mb-1 line-clamp-1">
              {storefront?.name}
            </h3>
            <p className="font-caption text-sm text-muted-foreground line-clamp-1">
              {storefront?.category} • {storefront?.zone}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2 mb-4">
          <div className="flex items-center gap-1">
            <Icon name="Star" size={16} fill="var(--color-warning)" color="var(--color-warning)" />
            <span className="font-body text-sm font-medium text-foreground">{storefront?.rating}</span>
          </div>
          <span className="text-muted-foreground">•</span>
          <div className="flex items-center gap-1 text-muted-foreground">
            <Icon name="MapPin" size={16} />
            <span className="font-caption text-sm">{storefront?.distance}</span>
          </div>
        </div>

        <div className="flex gap-2">
          <Button
            variant="default"
            size="sm"
            fullWidth
            iconName="ExternalLink"
            iconPosition="right"
            onClick={handleViewDetails}
          >
            Visualizza
          </Button>
          <Button
            variant="outline"
            size="sm"
            iconName="Navigation"
            iconPosition="left"
            onClick={() => navigate('/interactive-map')}
          >
            Mappa
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SavedStorefrontCard;